import { __decorate, __metadata } from "tslib";
import { IdItemModel, MinLength, Expose, ItemModelProp, EditorDefinition, CrudEndpoints, ItemModelDefinition, ModelId, Matches } from '@core/shared/model';
import { UseRestraints } from '@core/shared/restraints';
import { CompanyAddressRestraints } from "./company-address.restraints";
import { CompanyAddressType } from '../enum';
let CompanyAddressItem = /*#__PURE__*/(() => {
  let CompanyAddressItem = class CompanyAddressItem extends IdItemModel {
    toString() {
      return "CompanyAddress " + this.id;
    }
  };
  __decorate([Expose(), __metadata("design:type", Number)], CompanyAddressItem.prototype, "id", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], CompanyAddressItem.prototype, "companyId", void 0);
  __decorate([Expose(), __metadata("design:type", Function)], CompanyAddressItem.prototype, "company", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: CompanyAddressType.Postal
  }), __metadata("design:type", String)], CompanyAddressItem.prototype, "type", void 0);
  __decorate([ItemModelProp({
    defaultValueCreate: false
  }), Expose(), __metadata("design:type", Boolean)], CompanyAddressItem.prototype, "primary", void 0);
  __decorate([Expose(), MinLength(5, {
    message: 'Bitte geben Sie den Namen des Ansprechpartners / der Ansprechpartnerin an.'
  }), __metadata("design:type", String)], CompanyAddressItem.prototype, "personName", void 0);
  __decorate([Expose(), MinLength(3, {
    message: 'Bitte geben Sie den Namen des Unternehmens an.'
  }), __metadata("design:type", String)], CompanyAddressItem.prototype, "companyName", void 0);
  __decorate([Expose(), Matches(/^\D{3,}\s[\d]+\D?$/, {
    message: 'Bitte geben Sie die Anschrift an (Straße und Hausnummer).'
  }), __metadata("design:type", String)], CompanyAddressItem.prototype, "address", void 0);
  __decorate([Expose(), Matches(/^[\d]{5}$/, {
    message: 'Bitte geben Sie eine gültige Postleitzahl an.'
  }), __metadata("design:type", String)], CompanyAddressItem.prototype, "zipcode", void 0);
  __decorate([Expose(), MinLength(3, {
    message: 'Bitte geben Sie die Stadt an.'
  }), __metadata("design:type", String)], CompanyAddressItem.prototype, "city", void 0);
  CompanyAddressItem = __decorate([EditorDefinition('admin', {
    type: true,
    personName: true,
    companyName: true,
    address: true,
    zipcode: true,
    city: true,
    primary: 'readonly'
  }, {
    useCrudEndpoint: 'admin'
  }), EditorDefinition('create', {
    type: true,
    personName: true,
    companyName: true,
    address: true,
    zipcode: true,
    city: true,
    primary: 'readonly'
  }, {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/users/company-addresses'
  }), ItemModelDefinition({
    texts: {}
  }), UseRestraints(CompanyAddressRestraints), ModelId("CompanyAddressItem") // autogenerated by generate-model-ids
  ], CompanyAddressItem);
  return CompanyAddressItem;
})();
export { CompanyAddressItem };